import { useDispatch } from "react-redux";
import { GanttTabBarTab } from "../../types/ganttChart";
import {
  clearGanttChartData,
  setSelectedGanttChartTab,
} from "../../store/ganttChart";
import { useAppSelector } from "../../store/hooks";
import ViewTab from "../UI/tab/ViewTab";
import ViewTabsWrapper from "../UI/tab/ViewTabsWrapper";
import { openDragAndDropSessionWarningModal } from "../../store/dragAndDrop";

import { ReactComponent as EditIcon } from "../../assets/icons/edit_grey.svg";
import DragAndDropService from "../../service/dragAndDrop";
import RequestCancellationService from "../../service/requestCancellationService";
import { useEffect, useState } from "react";
import { Spinner } from "../UI/Spinner";

const GanttChartTabBar = () => {
  const dispatch = useDispatch();
  const { selectedGanttChartTab, ganttChartData } = useAppSelector(
    (state) => state.ganttChartSlice,
  );
  const { isDragAndDropTabOpen, customGanttChartData } = useAppSelector(
    (state) => state.dragAndDropSlice,
  );

  const [editIcon, setEditIcon] = useState<React.ReactElement>(<EditIcon />);
  const tabRow: GanttTabBarTab[] = [
    "Original",
    "Optimised",
    ...(isDragAndDropTabOpen /* Change name to isEditSessionCreated */
      ? (["Custom"] as GanttTabBarTab[])
      : []),
    ...(selectedGanttChartTab === "Optimised" &&
    ganttChartData &&
    !isDragAndDropTabOpen
      ? (["Edit"] as GanttTabBarTab[])
      : []) /* Edit is only allowed when there is a optimised plan available to edit. */,
  ];

  const getTabValue = (tab: GanttTabBarTab) => {
    switch (tab) {
      case "Original":
        return "Original Nexus Plan";
      case "Optimised":
        return `Optimeret plan `;
      case "Custom":
        return "Tilpasset Plan";
      case "Edit":
        return "Tilpas";
      default:
        return "Ukendt plan"; // Or handle other cases as needed
    }
  };

  const initiateCustomSession = async () => {
    setEditIcon(<Spinner width={18} height={18} />);
    await DragAndDropService.initiateSessionAndStoreData(
      ganttChartData!,
      dispatch,
    );
    setEditIcon(<EditIcon />);
  };

  return (
    <ViewTabsWrapper>
      {tabRow.map((tab) => (
        <ViewTab
          key={tab}
          selected={selectedGanttChartTab}
          icon={tab === "Edit" ? editIcon : undefined}
          onClick={() => {
            if (tab === selectedGanttChartTab) return;
            if (tab !== "Edit" && tab !== "Custom") {
              // Reset state
              dispatch(clearGanttChartData());
              // Cancel all active requests before starting a new batch
              const requestService = RequestCancellationService.getInstance();
              requestService.cancelAllRequests();
            }
            if (tab !== "Edit") {
              dispatch(setSelectedGanttChartTab(tab));
            } else if (!customGanttChartData && ganttChartData) {
              initiateCustomSession();
            }
          }}
          tabTypeName={tab}
          displayedTabName={getTabValue(tab)}
          fade={tab === "Custom"}
          onClose={
            tab === "Custom"
              ? () => {
                  dispatch(openDragAndDropSessionWarningModal());
                }
              : undefined
          }
        ></ViewTab>
      ))}
    </ViewTabsWrapper>
  );
};

export default GanttChartTabBar;
